import React from 'react';

import { useApiGet, useApiLoading } from 'react-reqq-lite';

import * as c from './constants';
import * as actions from './actions';

export const useGetRecentTransactions = (params, cb) => {
  const isApiLoading = useApiLoading(c.GET_RECENT_TRANSACTIONS, 'get');
  const list = useApiGet(`${c.GET_RECENT_TRANSACTIONS}.data`, []);
  const pagination = useApiGet(`${c.GET_RECENT_TRANSACTIONS}.pagination`, {});

  React.useEffect(() => {
    actions.getRecentTransactions(params, cb);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(params)]);

  return [isApiLoading, list, pagination];
};

export const useGetSelectedRecentTransaction = (params, cb, config) => {
  const isApiLoading = useApiLoading(c.GET_SELECTED_RECENT_TRANSACTION, 'get');
  const data = useApiGet(c.GET_SELECTED_RECENT_TRANSACTION, []);
  const { disableAction } = config || {};

  const refresh = ($params = {}, $cb) => {
    actions.getSelectedRecentTransaction(
      typeof $params === 'function'
        ? $params(params)
        : { ...params, ...$params },
      $cb || cb
    );
  };

  React.useEffect(() => {
    if (disableAction) return;
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(params), disableAction]);

  return [isApiLoading, data, refresh];
};
